import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./MarketingUIHelper";
const MarketingUIContext = createContext();

export function useMarketingUIContext() {
  return useContext(MarketingUIContext);
}

export const MarketingUIConsumer = MarketingUIContext.Consumer;

export function MarketingUIProvider({ marketingUIEvents, children }) {
  // initial filter
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  // Query Params set when do pagination ,filter,search
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const [ids, setIds] = useState([]);

  const value = {
    ids,
    setIds,
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    newBannerButtonClick: marketingUIEvents.newBannerButtonClick,
    openEditBannerPage: marketingUIEvents.openEditBannerPage,
    openDeleteBannerDialog: marketingUIEvents.openDeleteBannerDialog,
  };
  return (
    <MarketingUIContext.Provider value={value}>{children}</MarketingUIContext.Provider>
  );
}
